import {
  getAdGroupTemplateQueryOptions,
  getAdGroupTemplatesBySetupTemplateQueryOptions,
} from "../../queries/adGroupTemplates";
import { getSetupTemplatesQueryOptions } from "../../queries/setupTemplates";

// necessary entities are pre-fetched when a user hover a 'edit adGroupTemplate' link
export const adGroupTemplateFormLoader = ({ context: { queryClient } }) => {
  queryClient.ensureQueryData(getSetupTemplatesQueryOptions());
};

// adGroupTemplates are pre-fetched when a user hover a 'adGroupTemplates' link within a setupTemplate
export const adGroupTemplateListBySetupTemplateLoader = ({
  params,
  context: { queryClient },
}) => {
  const { setupTemplateId } = params;
  queryClient.ensureQueryData(
    getAdGroupTemplatesBySetupTemplateQueryOptions(setupTemplateId, queryClient)
  );
};

// adGroupTemplate is pre-fetched when a user hover a 'view adGroupTemplate' link
export const adGroupTemplateViewLoader = ({ params, context: { queryClient } }) => {
  const { adGroupTemplateId } = params;
  queryClient.ensureQueryData(
    getAdGroupTemplateQueryOptions(adGroupTemplateId, queryClient)
  );
};
